import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "../../axios"; // ✅ use your axios setup
import { Link, useNavigate } from "react-router-dom";

const BlogsList = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate(); // Add useNavigate hook

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get("/blogs"); // ✅ no need /api/ here
      setBlogs(response.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  const handleEdit = (id) => {
    // window.location.href = `/admin/addBlog/${id}`;
    navigate(`/admin/addBlog/${id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      try {
        await axios.delete(`/blogs/${id}`);
        fetchBlogs(); // Refresh after delete
      } catch (error) {
        console.error("Error deleting blog:", error);
        alert("Failed to delete blog");
      }
    }
  };

  const filteredData = blogs.filter(
    (blog) =>
      (blog.title ?? "").toLowerCase().includes(searchText.toLowerCase()) ||
      (blog.description ?? "").toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "100px",
      cell: (row, index) => <div className="text-center">{index + 1}</div>,
    },
    {
      name: "Blog Name",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => <div className="text-center">{row.title}</div>,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      cell: (row) => (
        <div className="text-center text-truncate" style={{ width: "500px" }}>
          {row.description}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="action-buttons justify-content-center">
          <button
            className="edit-btn"
            onClick={() => handleEdit(row.id)}
            title="Edit">
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(row.id)}
            title="Delete">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-header d-flex justify-content-between align-items-center">
        <h4>Blogs</h4>
        <Link to="/admin/addBlog" className="text-decoration-none">
          <button className="gold-add-btn text-white">+ Add Blog</button>
        </Link>
      </div>

      <input
        type="text"
        className="search-input my-4"
        placeholder="Search blogs..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div className="data-table-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          highlightOnHover
          responsive
          className="data-table"
          persistTableHead={true}
          noDataComponent={
            <div className="text-center py-4">No blogs found</div>
          }
        />
      </div>
    </div>
  );
};

export default BlogsList;
